// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AthenaLink-module__link____kAdW {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
}

.AthenaLink-module__link____kAdW:hover {
  border-color: #a1a1aa;
}

.AthenaLink-module__link____kAdW:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.AthenaLink-module__disabled___H6FWM {
  cursor: default;
  opacity: 0.7;
}

.AthenaLink-module__disabled___H6FWM:hover {
  border-color: #e4e4e7;
}

.AthenaLink-module__badge___CpGeY {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #18181b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.AthenaLink-module__badgeText___c4ukC {
  font-size: 10px;
  font-weight: 700;
  color: #fafafa;
  font-family: "IBM Plex Mono", monospace;
}

.AthenaLink-module__meta___fOJqF {
  flex: 1;
}

.AthenaLink-module__title___lpg0N {
  font-size: 11px;
  font-weight: 600;
}

.AthenaLink-module__mrn___lLBuN {
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 6px;
  font-family: "IBM Plex Mono", monospace;
}

.AthenaLink-module__arrow___h35dK {
  font-size: 13px;
  color: #a1a1aa;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/AthenaLink/AthenaLink.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mEAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF","sourcesContent":[".link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\n}\n\n.link:hover {\n  border-color: #a1a1aa;\n}\n\n.link:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.disabled:hover {\n  border-color: #e4e4e7;\n}\n\n.badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #18181b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.badgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.meta {\n  flex: 1;\n}\n\n.title {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mrn {\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.arrow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `AthenaLink-module__link____kAdW`,
	"disabled": `AthenaLink-module__disabled___H6FWM`,
	"badge": `AthenaLink-module__badge___CpGeY`,
	"badgeText": `AthenaLink-module__badgeText___c4ukC`,
	"meta": `AthenaLink-module__meta___fOJqF`,
	"title": `AthenaLink-module__title___lpg0N`,
	"mrn": `AthenaLink-module__mrn___lLBuN`,
	"arrow": `AthenaLink-module__arrow___h35dK`
};
module.exports = ___CSS_LOADER_EXPORT___;
